import { Component, inject } from '@angular/core';
import { ParentListViewProvider } from '@app/components/pretraga-kataloga/providers/parent-list-view.provider';
import { TreeViewProviderDirective } from '@app/providers';
import { BusinessItem, ItemActionResult } from '@ntap/core';
import { PrimeNGButtonSaveCloseItemActionComponent } from '@ntap/primeng';
import { Observable, tap } from 'rxjs';

@Component({
  selector: 'app-save-close-refresh-dok-action',
  templateUrl: '../../../shared/components/actions/common-action-template.html'
})
export class SaveCloseRefreshDokActionComponent extends PrimeNGButtonSaveCloseItemActionComponent {
  private parentListViewProvider = inject(ParentListViewProvider);

  protected override doExecuteWithItem(
    item: object
  ): Observable<ItemActionResult> {
    return super.doExecuteWithItem(item).pipe(
      tap(() => {
        const bi = new BusinessItem(item);
        if (this.parentListViewProvider instanceof TreeViewProviderDirective) {
          this.parentListViewProvider.nodeRefreshById(
            bi.data['en~jedinica_gradiva~nadredena_jedinica_gradiva']
          );
        }
      })
    );
  }
}
